export class CrearCuentaSmsPeticion {
    public codCliente: string;
    public codTpoPortal: string;
    public docEmpresa: string;
    public countryMovilUsuario: string;
    public movilUsuario: string;
    public tipoEnvio: string = '';
}